export type FilePreviewKind = 'pdf' | 'image' | 'unsupported';

export function filePreviewKind(fileName: string, mimeType?: string): FilePreviewKind {
  const mime = mimeType?.toLowerCase() ?? '';
  if (mime === 'application/pdf' || /\.pdf$/i.test(fileName)) return 'pdf';
  if (
    mime.startsWith('image/') ||
    /\.(png|jpe?g|gif|webp|bmp|svg)$/i.test(fileName)
  ) {
    return 'image';
  }
  return 'unsupported';
}
